import React from 'react';

import SourceBox from '../SourceBox';

import fetchContent from '../../helpers/backend-communication';
import { convertToMillion } from '../../helpers/format';

const assistanceProvidedColumns = ['Year', 'Amount', 'Projects'];
const assistanceReceivedColumns = ['Year', 'Projects'];

class OECDDatabase extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      oecdData: null
    };
  }

  componentDidMount(){
    const countryCode = this.props.countryCode;
    console.log("Fetching content for OECD Sourcebox....");

    fetchContent('oecd', `?country=${countryCode}`)
      .then(responseObject => {
        this.setState({
          oecdData: this.formatData(responseObject)
        });
      })
      .catch( error => {
        console.error("Fetch went wrong", error);
      });
  }

  formatData(data) {
    const formattedData = {
      provided: [],
      received: []
    };

    Object.keys(data).reverse().forEach(key => {
      const {
        total_projects_received,
        total_projects_provided,
        commitment
      } = data[key];

      if (total_projects_received > 0) {
        formattedData.received.push({
          Year: key,
          Projects: `${total_projects_received} projects`
        });
      }

      if (total_projects_provided > 0) {
        formattedData.provided.push({
          Year: key,
          Projects: `${total_projects_provided} projects`,
          Amount: `US$ ${convertToMillion(commitment)} million`
        });
      }
    });

    return formattedData;
  }

  buildSections() {
    const data = this.state.oecdData,
      sections = [];

    const assistancePagePath = `/international-assistance/${this.props.countryCode}`,
      assistanceProvidedSection = {
        title: 'Assistance provided',
        tables: [],
        footnote: (
          <p className="text-right">
            See more details
            <a href={ `${assistancePagePath}#oecd-provided` }> (projects and recipients)</a>
          </p>
        )
      },
      assistanceReceivedSection = {
        title: 'Assistance received',
        tables: [],
        footnote: (
          <p className="text-right">
            See more details
            <a href={ `${assistancePagePath}#oecd-received` }> (projects and donors)</a>
          </p>
        )
      };

    if (data.provided.length > 0) {
      assistanceProvidedSection.tables.push({
        data: data.provided,
        columns: assistanceProvidedColumns
      });

      sections.push(assistanceProvidedSection);
    }

    if (data.received.length > 0) {
      assistanceReceivedSection.tables.push({
        data: data.received,
        columns: assistanceReceivedColumns
      });

      sections.push(assistanceReceivedSection);
    }

    return sections;
  }

  render(){
    if (this.state.oecdData === null) { return null; }

    const description = (
      <span>
        Data source: OECD Creditor Reporting System (CRS) as reported by the Governments of OECD members&nbsp;
        <a href="http://stats.oecd.org/Index.aspx?datasetcode=CRS1#"
          target="_blank"
          rel="noopener noreferrer"
        >
          (data source)
        </a>
      </span>
    );

    return(
      <SourceBox
        title="International assistance: Reintegration and SALW control"
        info="The objective of the Creditor Reporting System (CRS) Aid Activity database is to provide a set of readily available basic data that enables analysis on where aid goes, what purposes it serves and what policies it aims to implement, on a comparable basis for all DAC members. Data are collected on individual projects and programmes. Focus is on financial data but some descriptive information is also made available. Data on ‘Reintegration and SLAW control’ is available under Sector 15240."
        logoClass="background-logo-oecd"
        description={ description }
        sections={ this.buildSections() }
      />
    );
  }
}

export default OECDDatabase



// WEBPACK FOOTER //
// ./src/components/RelatedDatabases/OECDDatabase.js